import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/index/HomePage',
        },
        //证书查询系统(search页面)
        {
            path: '/certSearchMobileHome',
            name: 'CertSearchMobileHome',
            component: () => import('../view/CertSearchMobileHome.vue')
        },
        {
            path: '/certSearchHome',
            name: 'CertSearchHome',
            component: () => import('../view/CertSearchHome.vue')
        },
         //证书查询(详情)
         {
            path: '/index/certQueryMobile',
            name: 'CertQueryMobile',
            component: () => import('../view/CertQueryMobile.vue')
        },
         {
            path: '/index/certQuery',
            name: 'CertQuery',
            component: () => import('../view/CertQuery.vue')
        },
         //考务管理
         {
            path: '/index/examManage',
            name: 'ExamManage',
            component: () => import('../view/ExamManage.vue')
        },
        //首页
        {
            path: '/index',
            name: 'index',
            component: () => import('../components/index.vue'),
            children: [                                                                                  
                //首页
                {
                    path: '/index/HomePage',
                    name: 'HomePage',
                    component: () => import('../components/HomePage.vue')
                },
                {
                    path: '/index/notice',
                    name: 'Notice',
                    component: () => import('../view/Notice.vue')
                },
                //新闻中心
                {
                    path: '/index/news',
                    name: 'News',
                    component: () => import('../view/News.vue')
                },
                //新闻中心详情
                {
                    path: '/index/newsDetail',
                    name: 'NewsDetail',
                    component: () => import('../view/NewsDetail.vue')
                },
                //联系我们
                {
                    path: '/index/contactUs',
                    name: 'ContactUs',
                    component: () => import('../view/ContactUs.vue')
                },
                //证书介绍
                {
                    path: '/index/certContent',
                    name: 'CertContent',
                    component: () => import('../view/CertContent.vue')
                },
                //在线考试
                {
                    path: '/index/examManage',
                    name: 'ExamManage',
                    component: () => import('../view/ExamManage.vue')
                },
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js